<template>
  <div ref="el"
       :contenteditable="note.editable"
       @input="onInput"
       @paste="onPaste"
       @keydown.enter="onReturn"
  >
    {{ initialValue }}
  </div>

</template>

<script lang="ts" setup>
import { defineProps, getCurrentInstance, nextTick, ref } from 'vue';
import QuestionNote from './QuestionNote';

const props = defineProps<{
  note: QuestionNote
}>();

const initialValue = ref(props.note.value.note);
const el = ref();
const vm = getCurrentInstance();

const onInput = () => {
  props.note.value.note = el.value.innerText;
  vm.emit('input');
}

const onCancel = () => {
  el.value.innerText = initialValue.value;
}

const onUpdate = () => {
  initialValue.value = props.note.value.note;
}

const focus = () => {
  nextTick(() => {
    el.value.focus();

    // var selection=document.getSelection();
    // var range=document.createRange();
    // let contenteditable = el.value
    //
    // if(contenteditable.lastChild.nodeType==3){
    //   range.setStart(contenteditable.lastChild,contenteditable.lastChild.length);
    // }else{
    //   range.setStart(contenteditable,contenteditable.childNodes.length);
    // }
    // selection.removeAllRanges();
    // selection.addRange(range);


    // const selection = window.getSelection();
    // const range = document.createRange();
    // selection.removeAllRanges();
    // range.selectNodeContents(el.value);
    // range.collapse(false);
    // selection.addRange(range);
  });
}

defineExpose({
  onCancel,
  onUpdate,
  focus,
  initialValue
});

const onPaste = (event) => {
  event.preventDefault();
  let text = (event.originalEvent || event).clipboardData.getData('text/plain');
  insertTextAtSelection(el.value, text);
  onInput();
}

const onReturn = (event) => {
  event.preventDefault();
  event.stopPropagation();
  insertTextAtSelection(el.value, '\n');
  onInput();
}

const insertTextAtSelection = (div, txt) => {
  let sel = window.getSelection();
  let text = div.textContent;
  let before = Math.min(sel.focusOffset, sel.anchorOffset);
  let after = Math.max(sel.focusOffset, sel.anchorOffset);
  let afterStr = text.substring(after);
  if (afterStr == "") afterStr = "\n";
  div.textContent = text.substring(0, before) + txt + afterStr;
  sel.removeAllRanges();
  let range = document.createRange();
  range.setStart(div.childNodes[0], before + txt.length);
  range.setEnd(div.childNodes[0], before + txt.length);
  sel.addRange(range);
}

</script>
